import React from 'react';

import local from './local.module.scss';

const SkeletonItem = ({ width, height }) => (
    <div style={{ width, height }} className={local.loadingAnimation} />
);

export default SkeletonItem;
